import React, { useState } from "react";
import IconSearch from "@/icons/IconSearch";

interface Props {
  onSearch(searchText: string): void;
  placeholderText: string;
}
export default function SearchBar(props: Props) {
  const [searchText, setSearchText] = useState<string>("");

  return (
    <div className="relative w-96 h-10">
      <div
        onClick={() => props.onSearch(searchText)}
        className="absolute inset-y-0 left-0 flex items-center pl-3"
      >
        <IconSearch width={16} height={16} className="text-zinc-400" />
      </div>
      <input
        type="text"
        id="search"
        className="items-center w-full h-full p-2 pl-10 text-sm text-zinc-900 border focus:outline-none border-zinc-300 rounded-lg bg-white dark:bg-zinc-700 dark:border-zinc-600 dark:placeholder-zinc-400 dark:text-white dark:focus:ring-(--ds-primary) dark:focus:border-(--ds-primary)"
        placeholder={props.placeholderText}
        onChange={(e) => {
          setSearchText(e.currentTarget.value);
          props.onSearch(e.currentTarget.value);
        }}
        onKeyDown={(e) => {
          if (e.code === "Enter") {
            props.onSearch(searchText);
          }
        }}
      ></input>
    </div>
  );
}
